// First-run intro. Fires once per browser (localStorage flag). Keeps the
// tone consistent with the newspaper metaphor: this is the "what is this?"
// page a stranger would read on a paper's masthead.

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';

const FLAG = 'onhere_welcomed_v1';

export function WelcomeModal() {
    const { authed } = useAuth();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!authed) return;
        if (localStorage.getItem(FLAG)) return;
        setOpen(true);
    }, [authed]);

    function dismiss() {
        localStorage.setItem(FLAG, '1');
        setOpen(false);
    }

    if (!open) return null;

    return (
        <div id="welcome-modal">
            <div className="welcome-backdrop" onClick={dismiss} />
            <div className="welcome-panel">
                <div className="welcome-masthead">
                    <div className="rule-top" />
                    <h1>Welcome to OnHere</h1>
                    <div className="issue">Your suburb's noticeboard</div>
                    <div className="rule-bottom" />
                </div>

                <div className="welcome-body">
                    <p>
                        OnHere is a <strong>hyperlocal bulletin board</strong> for the people who
                        actually live around you. Post an event, an offer, a heads-up — it shows
                        up on your suburb's daily paper. No algorithm boosts or buries it.
                    </p>

                    <div className="welcome-grid">
                        <div className="welcome-card">
                            <div className="welcome-emoji">📰</div>
                            <h3>Read the Paper</h3>
                            <p>Chronological feed of what's happening in Vredehoek — offers tonight, events this week, notices.</p>
                        </div>
                        <div className="welcome-card">
                            <div className="welcome-emoji">+</div>
                            <h3>Post something</h3>
                            <p>Hit the + up top. Choose Update, Offer, Event or Notice. Photos welcome.</p>
                        </div>
                        <div className="welcome-card">
                            <div className="welcome-emoji">👥</div>
                            <h3>Start a group</h3>
                            <p>Running a business, club, or NGO? <Link to="/manage" onClick={dismiss}>Create a group</Link> — you're auto-admin. Post as your group and see engagement stats.</p>
                        </div>
                        <div className="welcome-card">
                            <div className="welcome-emoji">🕶</div>
                            <h3>Real names, or anonymous</h3>
                            <p>Default is your name. Toggle anonymous per post and appear as "Anon in Vredehoek #XXXX". Real people, real accountability.</p>
                        </div>
                    </div>

                    <p className="welcome-fine">
                        No ads · No tracking · No algorithm ·{' '}
                        <Link to="/privacy" onClick={dismiss}>Privacy</Link> ·{' '}
                        <Link to="/rules" onClick={dismiss}>Community rules</Link> ·{' '}
                        <Link to="/settings" onClick={dismiss}>Your data controls</Link>
                    </p>
                </div>

                <div className="welcome-actions">
                    <button type="button" className="primary" onClick={dismiss}>Show me around</button>
                </div>
            </div>
        </div>
    );
}
